export const ALBUM_BACKEND = process.env.REACT_APP_ALBUM_BACKEND;
export const IMAGE_BACKEND = process.env.REACT_APP_IMAGE_BACKEND;
